import React from 'react'
import {
  MenuItemModGroup,
  MenuItemModVerb,
} from '../../../../types/groupOrder/menuItemMods'

interface MenuItemModGroupPreviewProps {
  group: MenuItemModGroup
}

const formatModVerb = (verb: MenuItemModVerb): string => {
  return verb.charAt(0).toUpperCase() + verb.slice(1).toLowerCase()
}

const MenuItemModGroupPreview: React.FC<MenuItemModGroupPreviewProps> = ({
  group,
}) => {
  return (
    <div className="w-1/3 p-4 bg-gray-300 flex flex-col">
      <div className="text-sm font-semibold text-blue-600 mb-2 text-center">
        Preview
      </div>
      <div
        className="preview-container p-4 border border-gray-400 rounded-lg bg-white shadow-lg"
        role="group"
        aria-labelledby={`preview-legend-${group.id}`}
      >
        <div
          id={`preview-legend-${group.id}`}
          className="font-bold text-gray-800 text-base mb-2"
        >
          {formatModVerb(group.verb)} {group.name}
          {group.isRequired ? ' (required)' : ' (optional)'}
        </div>
        <div className="h-full flex">
          <div className="space-y-2">
            {(group.mods || [])
              .filter((mod) => !mod.deletedAt)
              .map((mod, modIndex) => (
                <div key={mod.id || modIndex} className="flex items-center">
                  <input
                    type={group.isSingleOpt ? 'radio' : 'checkbox'}
                    name={`preview-group-${group.id}`}
                    id={`preview-mod-${mod.id}`}
                    className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                  />
                  <label
                    htmlFor={`preview-mod-${mod.id}`}
                    className="ml-3 block text-sm font-medium text-gray-700"
                  >
                    {mod.name}
                    {mod.clientPrice > 0 &&
                      ` (+$${mod.clientPrice.toFixed(2)})`}
                  </label>
                </div>
              ))}
            {(group.mods || []).filter((mod) => !mod.deletedAt).length ===
              0 && (
              <p className="text-gray-500 italic">
                No options in this group yet.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MenuItemModGroupPreview
